<template>
  <div class="products-summary">
    <template v-if="!branchNotFound">
      <v-container fluid>
        <v-row dense>
          <v-col cols="12">
            <v-card class="mx-auto" max-width="450px">
              <v-card-title class="text-title">
                Summary
                <span class="d-inline-block ml-auto success--text text-subtitle-1">
                  <v-icon class="success--text">mdi-circle-medium</v-icon>Live
                </span>
              </v-card-title>

              <v-fade-transition leave-absolute>
                <v-card-text
                  v-if="isLoadingSummary"
                  class="d-flex justify-center align-center mt-3"
                >
                  <v-progress-circular :size="70" color="primary darken-4" indeterminate></v-progress-circular>
                </v-card-text>

                <v-card-text v-else>
                  <div class="text-subtitle-2 grey--text">No.# Products: {{ numberOfProducts }}</div>

                  <div
                    class="text-subtitle-2 grey--text"
                  >Total Evaluation: GH₵ {{ productsEvaluation }}</div>

                  <div
                    class="text-subtitle-2 grey--text"
                  >No.# Quantifiable Products: {{ numberOfQuantifiableProducts }}</div>

                  <div
                    class="text-subtitle-2 grey--text mb-2"
                  >No.# Non-Quantifiable Products: {{ numberOfNonQuantifiableProducts }}</div>
                </v-card-text>
              </v-fade-transition>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn text color="primary darken-4" @click="$router.go(-1)">Go Back</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <v-container v-else>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Branch</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ProductsSummary",
  data() {
    return {
      isLoadingSummary: false,
      updater: null
    };
  },

  components: {},

  methods: {
    async getProductsSummary() {
      this.isLoadingSummary = true;
      var branchId = this.$route.params.branchId;

      await this.$store.dispatch("getProductsSummary", branchId).finally(() => {
        this.isLoadingSummary = false;
      });
    },

    async getProductsSummary2() {
      var branchId = this.$route.params.branchId;

      await this.$store.dispatch("getProductsSummary", branchId);
    }
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.updater);
    next();
  },

  watch: {
    $route() {
      this.getProductsSummary2();
    }
  },

  mounted() {
    this.getProductsSummary();

    this.updater = setInterval(() => {
      this.getProductsSummary2();
    }, 15000);
  },

  computed: {
    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    numberOfProducts() {
      if (this.$store.state.products.numberOfProducts && !this.isStaff)
        return this.$store.state.products.numberOfProducts;
      else return "Unavailable";
    },

    productsEvaluation() {
      if (this.$store.state.products.productsEvaluation && !this.isStaff)
        return this.$store.state.products.productsEvaluation;
      else return "Unavailable";
    },

    numberOfQuantifiableProducts() {
      if (
        this.$store.state.products.numberOfQuantifiableProducts &&
        !this.isStaff
      )
        return this.$store.state.products.numberOfQuantifiableProducts;
      else return "Unavailable";
    },

    numberOfNonQuantifiableProducts() {
      if (
        this.$store.state.products.numberOfNonQuantifiableProducts &&
        !this.isStaff
      )
        return this.$store.state.products.numberOfNonQuantifiableProducts;
      else return "Unavailable";
    },

    isStaff() {
      if (this.$store.state.user.user_type === "Staff") return true;
      else return false;
    }
  }
};
</script>

<style>
</style>